// source: https://ideal-postcodes.co.uk/guides/postcode-validation
export const postcodeRegex = new RegExp(/^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i);
